import axios from 'axios';
import {type MutationTree} from 'vuex';
import localStorage from '../../../../library/localStorage';

const mutations: MutationTree<ModulePageState> = {
    //<editor-fold desc="page list">
    setListDisplayType(state, data: {type: number, preventUpdate?: boolean})
    {
        state.listDisplayType = data.type ? 1 : 0;

        if (!data.preventUpdate)
        {
            axios.get(`/page/update-view/type/${state.listDisplayType}`)
            .catch(console.error);
        }

        localStorage.set('pageListDisplayType', state.listDisplayType);
    },
    //</editor-fold>
    //<editor-fold desc="file tree">
    setShowFileTree(state, data: {show: boolean, preventUpdate?: boolean})
    {
        state.showFileTree = data.show;

        if(!data.preventUpdate)
        {
            axios.get(`/page/update-view/view/${data.show ? 1 : 0}`)
            .catch(console.error);
        }

        localStorage.set('pageShowFileTree', state.showFileTree);
    },
    setOpenedFoldersFileTree(state, openedFolders: number[])
    {
        state.openedFoldersFileTree = openedFolders;
    },
    openFolder(state, folderId: number)
    {
        if (!state.openedFoldersFileTree)
        {
            return;
        }

        let i = state.openedFoldersFileTree.indexOf(folderId);

        if (-1 === i)
        {
            state.openedFoldersFileTree.push(folderId);
        }

        localStorage.set('pageFileTree', state.openedFoldersFileTree);
    },
    closeFolder(state, folderId: number)
    {
        if (!state.openedFoldersFileTree)
        {
            return;
        }

        let i = state.openedFoldersFileTree.indexOf(folderId);

        state.openedFoldersFileTree.splice(i, 1);

        localStorage.set('pageFileTree', state.openedFoldersFileTree);
    },
    //</editor-fold>
};

export default mutations;